import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IOption, IRouteOneDealer } from 'modules/core/types';
import { IDealer, IDealerStore } from 'modules/core/types/dealer';
import {
  getDealersThunk,
  getDealerStoresThunk,
  getPureDealerStoresThunk,
  getRouteOneDealersThunk,
} from 'actions/dealerActions';

import { sortDealers } from './utils/sortDealers';

export interface IDealerReducerState {
  dealers: IDealer[];
  routeOneDealers: IRouteOneDealer[];
  isRouteOneDealersLoading: boolean;
  dealerStores: IOption[];
  pureDealerStores: IDealerStore[];
}

const initialState: IDealerReducerState = {
  dealers: [],
  routeOneDealers: [],
  isRouteOneDealersLoading: false,
  dealerStores: [],
  pureDealerStores: [],
};

export const dealerSlice = createSlice({
  name: 'dealer',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      getDealerStoresThunk.fulfilled,
      (state: IDealerReducerState, { payload: dealerStores }: PayloadAction<IOption[]>) => ({
        ...state,
        dealerStores: sortDealers(dealerStores),
      }),
    );

    builder.addCase(
      getPureDealerStoresThunk.fulfilled,
      (state: IDealerReducerState, { payload: pureDealerStores }: PayloadAction<IDealerStore[]>) => ({
        ...state,
        pureDealerStores,
      }),
    );

    builder.addCase(
      getDealersThunk.fulfilled,
      (state: IDealerReducerState, { payload: dealers }: PayloadAction<IDealer[]>) => ({
        ...state,
        dealers,
      }),
    );

    builder.addCase(getRouteOneDealersThunk.pending, (state: IDealerReducerState) => ({
      ...state,
      isRouteOneDealersLoading: true,
    }));

    builder.addCase(
      getRouteOneDealersThunk.fulfilled,
      (state: IDealerReducerState, { payload: routeOneDealers }: PayloadAction<IRouteOneDealer[]>) => ({
        ...state,
        routeOneDealers,
        isRouteOneDealersLoading: false,
      }),
    );

    builder.addCase(getRouteOneDealersThunk.rejected, (state: IDealerReducerState) => ({
      ...state,
      isRouteOneDealersLoading: false,
    }));
  },
});
